import { render, staticRenderFns } from "./back_button.vue?vue&type=template&id=2975b3e8&scoped=true&"
import script from "./back_button.vue?vue&type=script&lang=js&"
export * from "./back_button.vue?vue&type=script&lang=js&"
import style0 from "./back_button.vue?vue&type=style&index=0&id=2975b3e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2975b3e8",
  null
  
)

export default component.exports